import React from "react";
import ReactDOM from "react-dom/client";
import { Routes, HashRouter, BrowserRouter, Route  } from "react-router-dom";
import Login from "./Login";
import Panel from "./Panel";
import Eventos from "./Eventos";
import FormAgregarEvento from "./Components/FormAgregarEvento";
import FormEditarEvento from "./Components/FormEditarEvento";
import RegistrarParticipantePaulet from "./RegistrarParticipantePaulet";
import Reporte from "./Reporte";
import ReporteSalon from "./ReporteSalon";
import ReporteParrillas from "./ReporteParrillas";

import LlenarDatos from "./LlenarDatos";
import RegistroExitoso from "./RegistroExitoso";
import RegistroExitosoParrilla from "./RegistroExitosoParrilla";

import EventosUser from "./User/EventosUser";
import PanelUser from "./User/PanelUser";
import MisEntradas from "./User/MisEntradas";
import MisReservas from "./User/MisReservas";

import Usuarios from "./Usuarios";
import FormEditarUsuario from "./Components/FormEditarUsuario";
import FormAgregarUsuario from "./Components/FormAgregarUsuario";
import PanelCDA from "./PanelCDA";
import EventosCDA from "./EventosCDA";
import AgregarEscenario from "./Components/AgregarEscenario";
import EditarEscenarioSalon from "./Components/EditarEscenarioSalon";
import FormIngresarPago from "./Components/FormIngresarPago";
import Colegiados from "./Colegiados";
import Cupones from "./Components/Cupones";
import ParrillasCDA from "./ParrillasCDA";

import RegistrarZonaParrilla from "./RegistrarZonaParrilla";


import RegistrarParticipanteSalon from "./RegistrarParticipanteSalon";
import Pagos from "./Pagos";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/" element={<Login />} />
        <Route exact path="/panelAdmin" element={<Panel />} />
        <Route exact path="/panelAdmin/eventos" element={<Eventos />} />
        <Route
          exact
          path="/panelAdmin/eventos/agregarEvento"
          element={<FormAgregarEvento />}
        />
        <Route
          exact
          path="/panelAdmin/eventos/agregarEvento/:idEvento"
          element={<AgregarEscenario />}
        />
		<Route
          exact
          path="/panelAdmin/eventos/:idEvento/editarEvento/"
          element={<EditarEscenarioSalon />}
        />
        <Route
          exact
          path="/panelAdmin/eventos/:id"
          element={<FormEditarEvento />}
        />
        <Route
          exact
          path="/eventos/:id/registrarParticipante"
          element={<RegistrarParticipantePaulet />}
        />
        <Route
          exact
          path="/eventos/:id/registrarParticipanteSalon"
          element={<RegistrarParticipanteSalon />}
        />
        <Route
          exact
          path="/panelAdmin/eventos/:id/reporte"
          element={<Reporte />}
        />
		 <Route
          exact
          path="/panelAdmin/eventos/:id/reporteSalon"
          element={<ReporteSalon />}
        />
		 <Route
          exact
          path="/zonaparrillas/reporte"
          element={<ReporteParrillas />}
        />
        <Route
          exact
          path="/eventos/:id/registrarParticipante/:idTicket"
          element={<RegistroExitoso />}
        />
		 <Route
          exact
          path="/zonaparrilla/:idReservaParrilla"
          element={<RegistroExitosoParrilla />}
        />
        <Route exact path="/panelAdmin/usuarios" element={<Usuarios />} />
        <Route exact path="/panelCDA/usuarios" element={<Usuarios />} />
        <Route
          exact
          path="/panelAdmin/usuario/:id"
          element={<FormEditarUsuario />}
        />
        <Route
          exact
          path="/panelAdmin/usuarios/agregarusuario"
          element={<FormAgregarUsuario />}
        />
        //USER
        <Route exact path="/panelUser/eventos/" element={<EventosUser />} />
        <Route exact path="/panelUser/" element={<PanelUser />} />{" "}
        <Route exact path="/panelUser/misEntradas" element={<MisEntradas />} />
		<Route exact path="/panelUser/misReservas" element={<MisReservas />} />

		<Route exact path="/eventos/:id/ingresarPago" element={<FormIngresarPago />} />

        //panelCDA
        <Route exact path="/panelCDA/" element={<PanelCDA />} />{" "}
        <Route exact path="/panelCDA/" element={<PanelCDA />} />{" "}
        <Route exact path="/panelCDA/eventos/" element={<EventosCDA />} />
		<Route exact path="/panelCDA/pagos/" element={<Pagos />} />
		<Route exact path="/panelCDA/colegiados/" element={<Colegiados />} />
		<Route exact path="/panelCDA/zonaparrillas/" element={<ParrillasCDA />} />
		<Route exact path="/panelCDA/zonaparrillas/:id/" element={<RegistrarZonaParrilla />} />

		<Route exact path="/panelAdmin/zonaparrillas/" element={<ParrillasCDA />} />
		<Route exact path="/panelAdmin/zonaparrillas/:id/" element={<RegistrarZonaParrilla />} />


		<Route exact path="/panelUser/zonaparrillas/" element={<ParrillasCDA />} />
		<Route exact path="/panelUser/zonaparrillas/:id/" element={<RegistrarZonaParrilla />} />



		<Route exact path="/panelAdmin/eventos/:id/cupones" element={<Cupones />} />

      </Routes>
    </HashRouter>
  </React.StrictMode>
);
